import http, {configForm, configJson} from "./config/http-configs";


/**
 * eg:
 * {
 *     "target":"MOBILE",
 *     "type":"HOME_WELCOME",
 *     "content":"上海领翔科技",
 *     "state":"VALID"
 * }
 */
export const setSystemSettingInfo = (data) => {
    const url = `/manage/setting/add`
    return http.post(url, data, configJson)
}

/**
 * system setting enum target:
 * MOBILE  设置应用在移动端
 * TERMINATE   设置应用在访客机端
 * MANAGE  设置应用在管理前端
 * ALL 所有的端都可以使用
 */

/**
 * system setting enum param
 * SYSTEM_NAME,     // 系统名称
 * COMPANY_LOGO,    // 公司logo
 * HOME_WELCOME,    // 首页欢迎语
 * USER_AGREEMENT,  // 用户协议
 * VISITOR_NOTICE,  // 访客须知
 * SECRET_AGREEMENT // 隐私协议
 */
export const getMobileSettingInfo = () => {
    //"targetList":["MOBILE", "TERMINATE"],
    // "typeList":["SYSTEM_NAME", "COMPANY_LOGO", "HOME_WELCOME"]
    const targetList = ["MOBILE"]
    const typeList = ["SYSTEM_NAME", "COMPANY_LOGO", "HOME_WELCOME"]
    // gf 的 []string 不拆逗号串：querystring 单键逗号分隔绑定为空导致恒查不到数据，须走 JSON body
    return http.post(`/manage/setting/list`, {targetList, typeList}, configJson)
}

export const getTerminateSettingInfo = () => {
    const targetList = ["TERMINATE"]
    const typeList = ["SYSTEM_NAME", "COMPANY_LOGO", "HOME_WELCOME", "HOME_BACKGROUND", "HOME_QR_REGISTER", "HOME_ENTER_SETTING", "HOME_BANNER_LIST"]
    // gf 的 []string 不拆逗号串：querystring 单键逗号分隔绑定为空导致恒查不到数据，须走 JSON body
    return http.post(`/manage/setting/list`, {targetList, typeList}, configJson)
}

export const getPublicSettingInfo = (type) => {
    const targetList = ["ALL"]
    const typeList = [type]

    return http.post(`/manage/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

export const getEntranceSetting = () => {
    const targetList = ["DOORGUARD"]
    const typeList = ["USUAL_RULE", "GENERAL_RULE"]
    // gf 的 []string 不拆逗号串：querystring 单键逗号分隔绑定为空导致恒查不到数据，须走 JSON body
    return http.post(`/manage/setting/list`, {targetList, typeList}, configJson)
}
export const getVisitorConfigSetting = () => {
    const targetList = ["VISITORINFO"]
    const typeList = ["VISITOR_BOOK"]
    return http.post(`/manage/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

// 员工的字段配置
export const getEmployeeSetting = () => {
    const targetList = ["EMPLOYEEINFO"]
    const typeList = ["UNIVERSAL"]
    return http.post(`/manage/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

// 签到方式 系统名称，公司logo
export const getManageConfigSetting = () => {
    const targetList = ["MANAGE"]
    const typeList = ["SYSTEM_NAME", "COMPANY_LOGO"]
    // gf 的 []string 不拆逗号串：querystring 单键逗号分隔绑定为空导致恒查不到数据（网页端设置保存后回显为空的根因），须走 JSON body
    return http.post(`/manage/setting/list`, {targetList, typeList}, configJson)
}


export const getInviteVisitorFormSetting = () => {
    const targetList = ["VISITORINFO"]
    const typeList = ["VISITOR_INVITE"]
    return http.post(`/manage/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

export const getTimerSettingList = () => {
    const targetList = ["TIMED_TASK"]
    const typeList = ["SYNC_CONTACTS", "DATA_BACKUP"]
    // gf 的 []string 不拆逗号串：querystring 单键逗号分隔绑定为空导致恒查不到数据，须走 JSON body
    return http.post(`/manage/setting/list`, {targetList, typeList}, configJson)
}

export const syncWxAccountOnce = () => {
    const url = '/manage/qywx/sync/contacts'
    // 同步接口串行调用企微 API，部门多时耗时长，放宽全局 10s 超时
    return http.get(url, {timeout: 120000})
}

export const checkWxSyncStatus = () => {
    const url = '/manage/qywx/sync/state'
    return http.get(url)
}

// 同步日志的企微 API 调用明细分页（含每次请求参数与完整响应）
export const getSyncLogDetails = (logId, current = 1, size = 20) => {
    const url = `/manage/qywx/sync/contacts/detail?logId=${logId}&current=${current}&size=${size}`
    return http.get(url)
}

export const getSystemInfoSetting = () => {
    const targetList = ["MANAGE"]
    const typeList = ["ENTERPRISE_INFO"]
    return http.post(`/manage/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

export const getSettingItem = (target, type) => {
    const targetList = [target]
    const typeList = [type]
    return http.post(`/manage/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}


// ============ 第三方集成配置（企业微信/微信公众号/微信小程序/阿里云短信/邮件） ============

// 各段生效值（DB 优先，回落服务端配置文件；密钥脱敏为 ******）
export const getIntegrationSetting = () => {
    const url = `/manage/setting/integration/list`
    return http.post(url, null, configForm)
}

// 保存一段配置：{type: "QYWX|WX_OFFICIAL|WX_MINI|SMS|MAIL", values: {完整配置键: 值}}
// 密钥字段留空或 ****** 表示不修改；保存后即时生效
export const saveIntegrationSetting = (data) => {
    const url = `/manage/setting/integration/save`
    return http.post(url, data, configJson)
}

// 发送测试邮件：用 MAIL 段表单当前值（未保存也参与）覆盖生效配置发送，不落库
export const sendMailTest = (data) => {
    const url = `/manage/setting/mail/test`
    return http.post(url, data, configJson)
}
